import { Spin } from 'antd'

// eslint-disable-next-line react/function-component-definition
export default function Loading() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
    >
      <Spin size="large" />
    </div>
  )
}
